import { Button, Paper, Popper, Stack, Typography } from '@mui/material';
import { Provider, type AwsVpcConnectivityConfig } from '@repo/api-gw-sdk';
import { useEffect, useState } from 'react';

import { RestoreRegionSelect } from '@/components/regions/restoreRegionSelect';
import { VpcSelect } from '@/components/regions/vpcSelect';

export const VpcSelectionDialog = ({
  accountId,
  onClose,
  buttonRef,
  config,
}: {
  accountId: string;
  onClose: (regionName: string | undefined, vpc: string | undefined) => void;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
  config: AwsVpcConnectivityConfig[];
}) => {
  const [regionName, setRegionName] = useState<string | undefined>('us-east-1');
  const [vpc, setVpc] = useState<string | undefined>(undefined);

  useEffect(() => {
    setVpc(undefined);
  }, [regionName]);

  return (
    <Popper
      anchorEl={buttonRef.current}
      disablePortal
      placement='bottom-start'
      open
    >
      <Paper
        className='shadow-lg'
        sx={{
          width: '308px',
          padding: '24px',
          borderRadius: '4px',
          marginTop: '-33px',
        }}
      >
        <Stack gap='24px'>
          <Typography>Choose a VPC</Typography>
          <RestoreRegionSelect
            restoreAccountId={accountId}
            regionName={regionName}
            onChange={(regionName) => setRegionName(regionName)}
            cloudProvider={Provider.Aws}
          />
          <VpcSelect
            disabledItems={config
              .filter((x) => x.region === regionName)
              .map((c) => c.vpc)}
            vpc={vpc}
            regionName={regionName}
            accountId={accountId}
            onChange={setVpc}
          />
          <Stack direction='row' gap='8px' justifyContent={'flex-end'}>
            <Button onClick={() => onClose(undefined, undefined)}>
              Cancel
            </Button>
            <Button
              onClick={() => onClose(regionName, vpc)}
              variant='contained'
              disabled={!regionName || !vpc}
            >
              Customize VPC
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Popper>
  );
};
